var _defs, _defs2, _g, _g2, _animateTransform, _animateTransform2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m2t03wqb27601909",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "m2t03wqb27601909_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03wqb27601909",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m2t03wqb27601909_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.01,0h63.98c0.00552,0 0.01,0.00448 0.01,0.01v63.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-63.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-63.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m2t03wqb27601909_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03wqd23953073_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,8,8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03wqd23953073",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m2t03ww624826642_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03ww624826642",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m2t03ww624826642_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.01,0h47.98c0.00552,0 0.01,0.00448 0.01,0.01v47.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-47.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-47.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m2t03ww624826642_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03ww786930334_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6,6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03ww786930334",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m2t03ww828127932_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03ww828127932",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m2t03ww828127932_stroke_path",
    d: "M0,18c0,4.7739 1.89642,9.35227 5.27208,12.72792c3.37565,3.37565 7.95403,5.27208 12.72792,5.27208c4.7739,0 9.35227,-1.89642 12.72792,-5.27208c3.37565,-3.37565 5.27208,-7.95402 5.27208,-12.72792c0,-4.7739 -1.89642,-9.35227 -5.27208,-12.72792c-3.37565,-3.37565 -7.95402,-5.27208 -12.72792,-5.27208",
    fill: "none",
    stroke: "rgb(28, 108, 42)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m2t03ww828127932_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1,0c0,-0.55228 0.44772,-1 1,-1c0.55228,0 1,0.44772 1,1c0,0.55228 -0.44772,1 -1,1c-0.55228,0 -1,-0.44772 -1,-1z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,0,18)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1,0c0,-0.55228 0.44772,-1 1,-1c0.55228,0 1,0.44772 1,1c0,0.55228 -0.44772,1 -1,1c-0.55228,0 -1,-0.44772 -1,-1z",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,18,8.881784197001252e-16)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -40,
    width: 120,
    height: 120,
    fill: "url(#m2t03ww828127932ps0)",
    mask: "url(#m2t03ww828127932_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m2t03wwf73003347_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,8,8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m2t03wwf73003347",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m2t03wwf73003347_stroke_path",
    d: "M20,10c0,-1.97781 -0.58649,-3.91121 -1.6853,-5.5557c-1.09881,-1.64449 -2.6606,-2.92622 -4.48786,-3.68309c-1.82726,-0.75688 -3.83793,-0.95491 -5.77774,-0.56906c-1.93981,0.38585 -3.72164,1.33826 -5.12017,2.73679c-1.39853,1.39853 -2.35093,3.18036 -2.73679,5.12017c-0.38585,1.93981 -0.18782,3.95048 0.56906,5.77774c0.75688,1.82726 2.0386,3.38905 3.68309,4.48786c1.64449,1.09881 3.57789,1.6853 5.5557,1.6853",
    fill: "none",
    stroke: "rgb(28, 108, 42)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m2t03wwf73003347_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1,0c0,-0.55228 0.44772,-1 1,-1c0.55228,0 1,0.44772 1,1c0,0.55228 -0.44772,1 -1,1c-0.55228,0 -1,-0.44772 -1,-1z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,20,10)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1,0c0,-0.55228 0.44772,-1 1,-1c0.55228,0 1,0.44772 1,1c0,0.55228 -0.44772,1 -1,1c-0.55228,0 -1,-0.44772 -1,-1z",
    transform: "matrix(1,0,0,1,9.999989999999997,20.000010000000003)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -24,
    width: 72,
    height: 72,
    fill: "url(#m2t03wwf73003347ps0)",
    mask: "url(#m2t03wwf73003347_gradient_mask)"
  }))))))))))))))))))))))))))))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#m2t03ww828127932",
    attributeName: "transform",
    type: "rotate",
    values: "0 18 18;360 18 18",
    dur: "2s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    href: "#m2t03wwf73003347",
    attributeName: "transform",
    type: "rotate",
    values: "0 10 10;-360 10 10",
    dur: "2s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;1",
    keySplines: "0.5 0.35 0.15 1",
    additive: "sum",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLoader);
export default __webpack_public_path__ + "static/media/upload-loader.167022d1199efd7bc2b46ec546866553.svg";
export { ForwardRef as ReactComponent };